import {Avatar} from '@mui/material';

export default Avatar;
